// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"aee1dd8c","109":"49d6fe8d","145":"225fa286","190":"57002087","496":"a93d752e","613":"4020565a","906":"01f6da09","948":"a635b66c","969":"daed3506"}[chunkId] + ".chunk.js";
};